module.exports = __webpack_public_path__ + "media/images/lp/ashinaga-aai/home/home-ticad9-image-21499b37a49e1e89c5bc71c0bfb68cbb.jpg";